module.exports = __webpack_public_path__ + "img/background.330812bd.png";